// extracted by mini-css-extract-plugin
export var calculatedBadge = "_wo-8";
export var container = "_wo-0";
export var radioDot = "_wo-5";
export var radioDotSelected = "_wo-6";
export var row = "_wo-1";
export var rowFirst = "_wo-2";
export var rowLast = "_wo-3";
export var rowSelected = "_wo-4";
export var strikethrough = "_wo-7";